import React, { useCallback } from 'react';
import cx from 'classnames';

import { btag, pushToDataLayer, SiteConfigManager } from '@atlas/core';
import { ChipsItem, Label } from '@atlas/ui';

import { useNotificationsUIContext } from 'src/common/Popup/NotificationsUIContext';

const LoadMoreButton = ({ handleClick, isShow }) => {
  const enableFooterForAllPages = SiteConfigManager.getConfig(
    'config.config.general.enableFooterForAllPages',
  );
  const enableExtendedFlyingBetslip = SiteConfigManager.getConfig(
    'config.config.betslip.enableExtendedFlyingBetslip',
  );
  const { isFlyingBetslip } = useNotificationsUIContext();

  const handleButtonClick = useCallback(() => {
    pushToDataLayer('load_more_games_click', btag);

    handleClick();
  }, [handleClick]);

  const className = cx('casino-load-more-block', {
    large: !enableFooterForAllPages && isFlyingBetslip && !enableExtendedFlyingBetslip,
  });

  return (
    <>
      {isShow && (
        <div className={className}>
          <ChipsItem
            className="casino-load-more-block__button"
            label={<Label message="casino_load_more_games" />}
            onClick={handleButtonClick}
          />
        </div>
      )}
    </>
  );
};

export default LoadMoreButton;
